module.exports = __webpack_public_path__ + "assets/img/settings-btn.a3a78acf.svg";